export function formatearPrecio(valor) {
  return Number(valor).toLocaleString("es-CO", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}


export const formatearPreciosDos = (valor) => {
  return new Intl.NumberFormat("es-CO", {
    minimumFractionDigits: 0,
  }).format(valor);
};